import React from 'react'
import styled from '@emotion/styled'

import Heading from '~/components/Heading'
import Natural from '~/icons/Natural'
import GlutenFree from '~/icons/GlutenFree'
import Fibre from '~/icons/Fibre'
import CBD from '~/icons/CBD'
import Wiggle from '~/icons/Wiggle'
import Nootropics from '~/icons/Nootropics'

import { breakpoints } from '~/utils/styles'

const Introduction = props => {
  const { title = 'What is <span>Nooro</span>?' } = props

  return (
    <WhatIs>
      <Wrapper>
        <IngredientsGrid>
          <div>
            <Nootropics fill="rgb(240, 149, 101)" />
            <h4>nootropics</h4>
            <p>maca & l-theanine give you an extra boost</p>
          </div>
          <div>
            <CBD fill="rgb(240, 149, 101)" />
            <h4>25mg CBD</h4>
            <p>well rounded dose of CBD for balanced calm</p>
          </div>
          <div>
            <Fibre fill="rgb(240, 149, 101)" />
            <h4>high fibre</h4>
            <p>for good gut health &amp; blood sugar levels</p>
          </div>
          <div>
            <GlutenFree fill="rgb(240, 149, 101)" />
            <h4>gluten free</h4>
            <p>all of our ingredients are ethically sourced</p>
          </div>
          <div>
            <Natural fill="rgb(240, 149, 101)" />
            <h4>low sugars</h4>

            <p>no additives, no nasty stuff. only natural</p>
          </div>
        </IngredientsGrid>
      </Wrapper>
    </WhatIs>
  )
}

export default Introduction

const WhatIs = styled.div`
  display: flex;
  background: #edebdf;
  align-items: center;
  color: #211f15;
  margin-top: -100px;
  padding-bottom: 100px;
  text-align: center;
  justify-content: center;

  p {
    font-size: 20px;
    max-width: 700px;
    margin: 0 auto;
  }

  @media (max-width: ${breakpoints.s}px) {
    padding: 40px 0;

    p {
      font-size: 16px;
    }
  }
`

const IngredientsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 20px;
  line-height: 1.6;

  h4 {
    letter-spacing: 0px;
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 10px;
    margin-top: 10px;
  }

  p {
    line-height: 1.6;
    font-size: 18px;
  }

  svg {
    width: 60px;
    height: 60px;
  }

  @media (max-width: ${breakpoints.s}px) {
    grid-template-columns: 1fr 1fr;
    font-size: 14px;
    margin-top: 20px;

    div {
      &:last-child {
        display: none;
      }
    }

    h4 {
      font-size: 16px;
    }

    p {
      font-size: 14px;
    }

    svg {
      width: 40px;
      height: 40px;
    }
  }
`

const Wrapper = styled.div`
  width: 90%;
  max-width: 1100px;
  position: relative;
  z-index: 1;
  margin: 0 auto;

  p {
    line-height: 1.6;
  }
`
